/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'

import { useAcompanhamentoCondicaoSaudeContext } from '../../context/AcompanhamentoCondicaoSaudeContext'
import { visitaDomiciliarMotivoByTematica } from './constants-acompanhamentoCondicaoSaudeAccordion'

interface AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSectionProps {
  dataUltimasVisitasDomiciliares: LocalDate[]
  qtdVisitasDomiciliares: number
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection({
  dataUltimasVisitasDomiciliares,
  qtdVisitasDomiciliares,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSectionProps>) {
  const { tematica } = useAcompanhamentoCondicaoSaudeContext()

  const motivoVisita = tematica && visitaDomiciliarMotivoByTematica[tematica]

  const tooltipText = visitaDomiciliarMotivoByTematica[tematica]
    ? `Apenas visitas de acompanhamento com o motivo preenchido como ${motivoVisita}`
    : undefined

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon icon='houseFilled' size={1} color={iconColor} />
          <Heading level={4}>Visitas domiciliares (últimos 36 meses)</Heading>
          {tooltipText && <InfoIcon icon='infoCircleFilled' text={tooltipText} tooltipStyle={tooltipStyle} />}
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Quantidade'>{qtdVisitasDomiciliares}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Últimas visitas' placeholder='-'>
          {dataUltimasVisitasDomiciliares?.map(formatDate).join(' e ')}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}

const tooltipStyle = css`
  max-width: 31rem;
  white-space: pre-line;
`
